import { type ReactElement } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';

import { IsActive } from 'hb-react/shared/components/IsActive';

export const Section = ({
  children,
  isActive = true,
  title,
}: {
  children: Array<ReactElement> | ReactElement;
  isActive?: boolean;
  title?: string;
}) => (
  <IsActive isActive={isActive}>
    {title ? (
      <CardWithTitle
        my={{ _: 2, m: 6 }}
        pb="0"
        title={title}
        noBorderRadiusOnSmallScreen
      >
        <Box display="block">{children}</Box>
      </CardWithTitle>
    ) : (
      <>{children}</>
    )}
  </IsActive>
);
